import React, { Component } from 'react';

import Link from '../../../../shared/components/hyperlink';
import Icon from '../../../../ui/components/icon';

class ArticleArchives extends Component {

  constructor(props) {
    super(props);
    this.state = {
      articleArchives: [],
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.articleArchives && Object.keys(nextProps.articleArchives).length) {

      const { hits:articleArchives } = nextProps.articleArchives;
      const { hits, total:totalHits } = articleArchives || {};

      let blogs = hits.map((hit) => {
        return hit['_source'];
      });

      return {
        articleArchives: blogs,
      }

    }
    return null;
  }

  render() {

    const {articleArchives} = this.state;

    return (
      <div className="article-archives">
      { articleArchives.length > 0 &&
        <span>
        <h3>Article archives</h3>
        <hr/>
        <ul>
        {
          articleArchives.map((article, index) => {
            const {vanityUrl, blogTitle} = article;
            return (
              <li key={index} className="article-archive-item-container">
                <Icon size={20} name="right_small"/>
                <Link className="article-archive-item" to={`/${vanityUrl}`}>{blogTitle}</Link>
              </li>
            );
          })
        }
        </ul>
        </span>
      }
      </div>


    )
  }

}

export default ArticleArchives;
